/*
  Iterate over all the links in the ia_map and remove any that
  don't pass permissions checks.
*/

const IaPermissionMapper = async (iaMap, permissionsMap) => {
  const isEntitled = link => {
    return link.entitlements.find(entitlementString => {
      return permissionsMap[entitlementString] && permissionsMap[entitlementString].enabled;
    });
  };

  const isPermitted = async link => {
    return link.entitlements ? Promise.resolve(isEntitled(link)) : Promise.resolve(true);
  };

  let mapLinkGroup;

  const mapLink = async link => {
    if (Array.isArray(link)) {
      return mapLinkGroup(link);
    }

    if (await isPermitted(link)) {
      const newLink = { ...link };
      newLink.children = await mapLinkGroup(link.children || []);
      return newLink;
    }

    return null;
  };

  mapLinkGroup = async linkGroup =>
    (await Promise.all(linkGroup.map(async l => mapLink(l)))).filter(x => !!x);

  const linkGroupPromises = Object.keys(iaMap).map(async key => {
    const result = {};
    result[key] = await mapLinkGroup(iaMap[key]);
    return result;
  });
  const linkGroupResults = (await Promise.all(linkGroupPromises)).reduce(
    (all, curr) => ({ ...all, ...curr }),
    {}
  );

  return linkGroupResults;
};

export default IaPermissionMapper;



// WEBPACK FOOTER //
// ./app/javascript/app/components/nav/ia_permission_mapper.js